export const explanationData = {
  1: {
    buttonText: "Next",
    header: "All writers revise",
    imageData: {
      imageAlt: "An illustration of a pencil circled with a revision",
      imageUrl: "images/evidence/revising-pencil.svg"
    },
    isBeta: false,
    step: 2,
    subtext: "Your goal is to practice and improve your writing skills.<br />We will provide you with a lot of feedback on your writing. You’ll be able to revise each sentence up to five times so that you can become a stronger writer."
  },
  2: {
    buttonText: "Next",
    header: "We use a feedback bot",
    imageData: {
      imageAlt: "An illustration of a smiling robot head",
      imageUrl: "images/evidence/feedback-bot.svg"
    },
    isBeta: true,
    step: 3,
    subtext: "We use artificial intelligence (AI) to help us give you feedback on your writing. You should know that AI isn't always correct."
  },
  3: {
    buttonText: "Start",
    header: "Your teacher will see your score and writing",
    imageData: {
      imageAlt: "An illustration of a report page with a magnifying glass over it",
      imageUrl: "images/evidence/evidence-report.svg"
    },
    isBeta: false,
    step: 4,
    subtext: "Once the activity is complete, both you and your teacher will see a report with your score and your responses for each prompt."
  },
}
